import { Injectable, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalVideoService implements OnDestroy {
  private showModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private videoId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private videoSrc: BehaviorSubject<SafeResourceUrl> =
    new BehaviorSubject<SafeResourceUrl>(
      this.sanitizer.bypassSecurityTrustResourceUrl('')
    );
  private activatedRouteSubscription$!: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  openModalVideo(): {
    showModal: boolean;
    videoId: string;
    videoSrc: SafeResourceUrl;
  } {
    let result: {
      showModal: boolean;
      videoId: string;
      videoSrc: SafeResourceUrl;
    } = {
      showModal: false,
      videoId: '',
      videoSrc: this.sanitizer.bypassSecurityTrustResourceUrl(''),
    };
    this.activatedRouteSubscription$ =
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        if (params['videoId']) {
          this.showModal.next(true);
          this.videoId.next(params['videoId']);
          this.videoSrc.next(this.getVideoSrc(params['videoId']));
          result = {
            showModal: true,
            videoId: params['videoId'],
            videoSrc: this.videoSrc.getValue(),
          };
        } else {
          this.showModal.next(false);
          result = {
            showModal: false,
            videoId: '',
            videoSrc: this.sanitizer.bypassSecurityTrustResourceUrl(''),
          };
        }
      });
    return result;
  }

  getModalState() {
    return this.showModal.asObservable();
  }

  getVideoId() {
    return this.videoId.asObservable();
  }

  // TODO: Eventually save the video in cache when it is copied from the clipboard
  getVideoSrc(id: string): SafeResourceUrl {
    const hasNonDigits = /[a-zA-Z\-_]/.test(id);

    if (hasNonDigits) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${id}`
      );
    }

    if (/^\d+$/.test(id)) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://player.vimeo.com/video/${id}`
      );
    }

    return '';
  }

  ngOnDestroy() {
    this.activatedRouteSubscription$?.unsubscribe();
  }
}
